import {
  API_KEYS,
  APP_TYPE,
  WEBVIEW_TYPES,
  LOCAL_STORAGE_KEYS,
} from '@/lib/consts.ts'

export function chooseApiKey (apiUrl: string) {
  // allow to override api key on "development" mode (local build)
  if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_API_KEY) {
    return process.env.VUE_APP_API_KEY
  }

  const app = getApiKeyFromLocalStorage()
  const env = getEnvironment()

  return API_KEYS[app][env]
}

function getApiKeyFromLocalStorage () {
  const appType = localStorage.getItem(LOCAL_STORAGE_KEYS.APP_APP_TYPE) || APP_TYPE.PWA
  let app = localStorage.getItem(LOCAL_STORAGE_KEYS.APP_WEB_VIEW) || WEBVIEW_TYPES.WWW
  app = appType === APP_TYPE.MOBILE ? `${app}_${APP_TYPE.MOBILE}` : app

  return app
}

function getEnvironment () {
  return window.location.origin.match(/booksy\.com/) ? 'live' : 'dev'
}
